module.exports = __webpack_public_path__ + "img/wr1-3.1984016e.png";